import React, { useState, useEffect } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import Moment from "moment";
import Select from "react-select";
// components
import Navbar from "../../Components/Navbar/Navbar";
import Table from "../../Components/TableTemplate/OneTable";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AdjustmentTable from "./../Inventory/Adjustment/AdjustmentTable";
import downloadIcon from "../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

// api calls and utils
import {
    deleteInvoice,
    getAllInvoices,
} from "../../Helpers/apiCalls/Sales/franchiseInvoice";
import {
    numberFormat,
    numberFormatInt,
    getType,
    refreshPage,
    toastStyle,
    TokenExpiry,
} from "../../Helpers/Utils/Common";

// css
import "./SalesInvoice.css";
import "../Purchases/PurchaseOrders/PurchaseOrders.css";
import { getAllFranchisee, searchFranchiseeSales } from "../../Helpers/apiCalls/franchiseeApi";
import MultiplePaymentModal from "./MultiplePaymentModal";
import CloseFSModal from "./CloseFSModal";

/**
 *  Sales Invoice Register component
 */
export default function SalesInvoice() {
    let navigate = useNavigate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [salesInvoiceManager, setSalesInvoiceManager] = useState([]);
    const [total, setTotal] = useState([]);
    const [totalPaid, setTotalPaid] = useState([]);
    const [totalBalance, setTotalBalance] = useState([]);
    const [openListPI, setOpenListPI] = useState([]);
    const [closeListPI, setCloseListPI] = useState([]);
    const [requestListPI, setRequestListPI] = useState([]);
    const [quotation, setQuotation] = useState([]);
    const [franchisees, setFranchisees] = useState([]);
    const [branches, setBranches] = useState ([]);
    const [branch, setBranch] = useState("");
    const [checkedItems, setCheckedItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [excelData, setExcelData] = useState([]);
    
    const orderQuoteHeaders =  [ "ORDER DATE", "DLVRY DATE", "DOC. NO", "FRANCHISEE", "BRANCH", "TOTAL", "STATUS" ]
    const orderRequestHeaders =  [ "ORDER DATE", "DLVRY DATE", "DOC. NO", "FRANCHISEE", "BRANCH", "TOTAL", "STATUS" ]
    const openInvoiceHeaders =  [ "SALES DATE", "INV NO.", "FRANCHISEE", "FROM", "BRANCH", "TOTAL", "PAID AMNT", "BALANCE", "STATUS" ]
    const closedInvoiceHeaders =  [ "SALES DATE", "INV NO.", "FRANCHISEE", "FROM", "BRANCH", "TOTAL", "PAID AMNT", "BALANCE", "STATUS" ]
    const refundableHeaders =  [ "SALES DATE", "INV NO.", "FRANCHISEE", "FROM", "BRANCH", "TOTAL", "PAID AMNT", "RFND PMT", "STATUS", ]
    const allDataHeaders =  [ "SALES DATE", "INV NO.", "FRANCHISEE", "FROM", "BRANCH", "TOTAL", "PAID AMNT", "BALANCE", "STATUS" ]


    useEffect(()=>{
        // 
        setBranches(franchisees.map((franchisee)=>{
            return {label: franchisee.branch_name, value:franchisee.branch_id};
        }))
        setBranches((branches)=>{
            var newBranches = [...branches];
            newBranches.push({label: "All Branches", value:""})
            return newBranches.reverse();
        });

        // 
    },[franchisees])

    function handleBranchChange(e){
        setBranch(e.name);
        const toFilter = {target: {name: "branch_id", value: e.value}};
        handleFilterChange(toFilter);
    }

    /* Close bill Modal */
    const [showCloseBillModal, setShowCloseBillModal] = useState(false);
    const handleShowCloseBillModal = () => setShowCloseBillModal(true);
    const handleCloseCloseBillModal = () => setShowCloseBillModal(false);
    const [bill, setBill] = useState([]);


    /* FILTER CONFIGS */
    const [filterConfig, setFilterConfig] = useState({
        tab: "order_quotation",
        franchisee_name: "",
        invoice_no: "",
        invoice_status: "",
        date_from: "",
        date_to: "",
        tabKey: "",
        payment_status: "",
        fs_status: "quoted", // quoted if order quotation una
    });

    function handleFilterChange(e) {
        // 
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    const [showLoader, setShowLoader] = useState(false);

    async function searchFranchiseeApi() {
        setShowLoader(true);
        setSalesInvoiceManager([]);
        const response = await searchFranchiseeSales(filterConfig);
        // 

        if (response.data) {
            var allBills = response.data.data.map((data) => {
                var franchise = data;
                var stat = data.payment_status.split("_")
                franchise.isClosedBill = data.payment_status === "closed_bill" ? true : false
                franchise.payment_status = stat.length < 2 ? data.payment_status : stat[0] + " " + stat[1];
                franchise.franchised_on =
                    Moment(franchise.franchised_on).format("MM-DD-YYYY") || "N/A";
                franchise.grand_total = numberFormat(franchise.grand_total);
                franchise.paid_amount = numberFormat(franchise.paid_amount);
                franchise.balance = data.payment_status !== "overpaid" ? numberFormat(franchise.balance) : numberFormat(franchise.balance.split("-")[1]);
                franchise.order_request_date = Moment(franchise.order_request_date).format("MM-DD-YYYY");
                franchise.delivery_date = Moment(franchise.delivery_date).format("MM-DD-YYYY");
                franchise.sales_date = Moment(franchise.sales_date).format("MM-DD-YYYY");                    
                return franchise;
            });
            var total = response.data.summary? response.data.summary.total : "0";
            var total_paid_amount = response.data.summary? response.data.summary.total_paid_amount : "0";
            var total_balance = response.data.summary? response.data.summary.total_balance : "0";
            setSalesInvoiceManager(allBills.reverse());
            setTotal(total);
            setTotalPaid(total_paid_amount);
            setTotalBalance(total_balance);
            
            if(filterConfig.tab === "order_quotation") {
                var data = allBills.reverse()
                var excel = data.map((bill) => {
                    var info = {};
                    info.order_request_date = bill.order_request_date
                    info.delivery_date = bill.delivery_date
                    info.id = bill.id
                    info.franchisee_name = bill.franchisee_name
                    info.buyer_branch_name = bill.buyer_branch_name
                    info.balance = bill.balance
                    info.payment_status = bill.payment_status
                    return info;
                });
                setExcelData(excel)
            } else if(filterConfig.tab === "order_request") {
                var data = allBills.reverse()
                var excel = data.map((bill) => {
                    var info = {};
                    info.order_request_date = bill.order_request_date
                    info.delivery_date = bill.delivery_date
                    info.id = bill.id
                    info.franchisee_name = bill.franchisee_name
                    info.buyer_branch_name = bill.buyer_branch_name
                    info.grand_total = bill.grand_total
                    info.payment_status = bill.payment_status
                    return info;
                });
                setExcelData(excel)
            } else if(filterConfig.tab === "open_invoices" || filterConfig.tab === "closed_invoices" || filterConfig.tab === "all") {
                var data = allBills.reverse()
                var excel = data.map((bill) => {
                    var info = {};
                    info.sales_date = bill.sales_date
                    info.id = bill.id
                    info.franchisee_name = bill.franchisee_name
                    info.seller_branch_name = bill.seller_branch_name
                    info.buyer_branch_name = bill.buyer_branch_name
                    info.grand_total = bill.grand_total
                    info.paid_amount = bill.paid_amount
                    info.balance = bill.balance
                    info.payment_status = bill.payment_status
                    return info;
                });
                setExcelData(excel)
            } else if(filterConfig.tab === "refundable") {
                var data = allBills.reverse()
                var excel = data.map((bill) => {
                    var info = {};
                    info.sales_date = bill.sales_date
                    info.id = bill.id
                    info.franchisee_name = bill.franchisee_name
                    info.seller_branch_name = bill.seller_branch_name
                    info.buyer_branch_name = bill.buyer_branch_name
                    info.grand_total = bill.grand_total
                    info.paid_amount = bill.paid_amount
                    info.balance = bill.balance
                    info.payment_status = bill.payment_status
                    return info;
                });
                setExcelData(excel)
            }

        } else if (response.error) {
            TokenExpiry(response);
            setSalesInvoiceManager([]);
        }
        setShowLoader(false);
    }
    
    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        if(filterConfig.tab === "order_quotation") {
            XLSX.utils.sheet_add_aoa(worksheet, [orderQuoteHeaders], { origin: "A1" });
            XLSX.writeFile(workbook, "OrderQuote.xlsx", { compression: true });
        } else if(filterConfig.tab === "order_request") {
            XLSX.utils.sheet_add_aoa(worksheet, [orderRequestHeaders], { origin: "A1" });
            XLSX.writeFile(workbook, "OrderRequest.xlsx", { compression: true });
        } else if(filterConfig.tab === "open_invoices") {
            XLSX.utils.sheet_add_aoa(worksheet, [openInvoiceHeaders], { origin: "A1" });
            XLSX.writeFile(workbook, "OpenInvoices.xlsx", { compression: true });
        } else if(filterConfig.tab === "closed_invoices") {
            XLSX.utils.sheet_add_aoa(worksheet, [closedInvoiceHeaders], { origin: "A1" });
            XLSX.writeFile(workbook, "ClosedInvoices.xlsx", { compression: true });
        } else if(filterConfig.tab === "refundable") {
            XLSX.utils.sheet_add_aoa(worksheet, [refundableHeaders], { origin: "A1" });
            XLSX.writeFile(workbook, "Refundable.xlsx", { compression: true });
        } else if(filterConfig.tab === "all") {
            XLSX.utils.sheet_add_aoa(worksheet, [allDataHeaders], { origin: "A1" });
            XLSX.writeFile(workbook, "RetailSalesInvoice.xlsx", { compression: true });
        }
    }

    useEffect(() => {
        searchFranchiseeApi();
    }, [filterConfig]);

    // async function fetchPI() {
    //     setShowLoader(true);
    //     setOpenListPI([]);
    //     setCloseListPI([]);
    //     setQuotation([]);


    //     const response = await getAllInvoices();
    //     //

    //     if (response.error) {
    //         TokenExpiry(response.error);
    //     } else if (response.data) {
    //         var allFranchiseeSalesInvoice = response.data.data.map(
    //             (invoice) => {
    //                 var info = invoice;
    //                 info.order_request_date = Moment(invoice.order_request_date).format("MM-DD-YYYY");
    //                 info.delivery_date = Moment(invoice.delivery_date).format("MM-DD-YYYY");
    //                 info.sales_date = Moment(invoice.sales_date).format("MM-DD-YYYY");
    //                 info.grand_total = numberFormat(invoice.grand_total);
    //                 info.paid_amount = numberFormat(invoice.paid_amount);
    //                 info.balance = numberFormat(invoice.balance);

    //                 return info;
    //             }
    //         );
    //         //
    //         //
    //         var closedBills = [];
    //         var openBills = [];
    //         var requests = [];
    //         var quotation = [];
    //         closedBills = allFranchiseeSalesInvoice.filter(
    //             (bill) => bill.payment_status === "closed_bill"
    //         );
    //         openBills = allFranchiseeSalesInvoice.filter(
    //             (bill) =>
    //                 bill.payment_status === "open_bill" &&
    //                 bill.franchisee_sale_payments.length !== 0
    //         );
    //         quotation = allFranchiseeSalesInvoice.filter(
    //             (bill) =>
    //                 bill.fs_status === "quoted"
    //         );
    //         requests = allFranchiseeSalesInvoice.filter(
    //             (bill) =>
    //                 bill.fs_status === "quoted"
    //                 && bill.payment_status === "processing"
    //         );
    //         setCloseListPI(closedBills);
    //         setOpenListPI(openBills);
    //         setRequestListPI(requests);
    //         setQuotation(quotation);
    //     }
    //     setShowLoader(false);
    // }

    async function fetchFranchisee() {
        setShowLoader(true);

        const response = await getAllFranchisee();

        if (response.error) {
            TokenExpiry(response.error);
        } else {
            //
            setFranchisees(response.data.data);
        }
        setShowLoader(false);
    }

    /* add payment modal handler */
    const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);
    const handleShowAddPaymentModal = () => setShowAddPaymentModal(true);
    const handleCloseAddPaymentModal = () => setShowAddPaymentModal(false);

    /* add multiple payment modal handler */
    const [showMultiplePaymentModal, setShowMultiplePaymentModal] = useState(false);
    const handleShowMultiplePaymentModal = () => setShowMultiplePaymentModal(true);
    const handleCloseMultiplePaymentModal = () => setShowMultiplePaymentModal(false);

    /* delete modal handler */
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const [PIID, setPIID] = useState("");
    const [franchiseeID, setFranchiseeID] = useState("");
    const [isClicked, setIsClicked] = useState(false);

    async function handleDeletePI() {
        setIsClicked(true);
        const response = await deleteInvoice(PIID);
        // 

        if (response.data.status === "success") {
            toast.success("Sales Invoice Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            toast.error("Error Deleting Sales Invoice", {
                style: toastStyle(),
            });
        }
    }

    const [bal, setBal] = useState("");
    const [invoice, setInvoice] = useState("");

    function handleSelectChange(e, id, franchisee_id, balance, row) {
        
        setBill(row)
        setSelectedItem([row])
        if (e.target.value === "edit-pi") {
            navigate("edit/" + id);
        } else if (e.target.value === "add-invoice-pi") {
            navigate("createinvoice/" + id);
        } else if (e.target.value === "process-req") {
            navigate("process/" + id);
        } else if (e.target.value === "print-pi") {
            // navigate("print/" + id);
            window.open(
                "salesinvoice/print/" + id, "_blank"
            );
        } else if (e.target.value === "payment-pi") {
            setPIID(id);
            setFranchiseeID(franchisee_id);
            setBal(numberFormatInt(balance));
            handleShowAddPaymentModal();
        } else if (e.target.value === "multiple-payment-pi") {
            // setPIID(id);
            // setFranchiseeID(franchisee_id);
            // setBal(numberFormatInt(balance));
            var balance = checkedItems.map((data) => {
                return parseFloat(numberFormatInt(data.balance))
            }).reduce((a, b) => a + b, 0);
            setBal(balance);
            handleShowMultiplePaymentModal();
        } else if (e.target.value === "delete-pi") {
            setPIID(id);
            handleShowDeleteModal();
        }  else if (e.target.value === "close-pi") {
            handleShowCloseBillModal();
        }
    }

    const handleTabSelect = (tabKey) => {
        var newFilterConfig = {
            tab: tabKey,
        };

        switch (tabKey) {
            case "order_quotation":
                setSalesInvoiceManager([]);
                newFilterConfig.fs_status = "quoted";
                setFilterConfig(() => {
                    return newFilterConfig;
                });
                break;
            case "order_request":
                setSalesInvoiceManager([]);
                setCheckedItems([]);
                newFilterConfig.fs_status = "processing";
                newFilterConfig.payment_status = ""; // both open and closed bills
                setFilterConfig(() => {
                    return newFilterConfig;
                });
                break;
            case "open_invoices":
                setSalesInvoiceManager([]);
                setCheckedItems([]);
                newFilterConfig.fs_status = "invoiced";
                newFilterConfig.payment_status = "open_bill";
                setFilterConfig(() => {
                    return newFilterConfig;
                });
                break;
            case "closed_invoices":
                const date = new Date();
                date.setDate(date.getDate() - 7);

                setSalesInvoiceManager([]);
                newFilterConfig.fs_status = "invoiced";
                newFilterConfig.payment_status = "closed_bill";
                newFilterConfig.date_from = new Date(date);
                newFilterConfig.date_to = new Date();
                setFilterConfig(() => {
                    return newFilterConfig;
                });
                break;
            case "refundable":
                setSalesInvoiceManager([]);
                newFilterConfig.payment_status = "overpaid";
                setFilterConfig(() => {
                    return newFilterConfig;
                });
                break;
            case "all":
                setSalesInvoiceManager([]);
                setCheckedItems([]);
                newFilterConfig.fs_status = "";
                newFilterConfig.payment_status = "";
                setFilterConfig(() => {
                    return newFilterConfig;
                });
                break;
            default:
                setSalesInvoiceManager([]);
                break;
        }
    };

    
    function handleOnCheck(row) {
        setCheckedItems(row.selectedRows);
    }
    

    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) =>
                    handleSelectChange(
                        e,
                        row.id,
                        row.franchisee_id,
                        row.balance,
                        row
                    )
                }
            >
                <option value="" hidden selected>
                    Select
                </option>
                {type === "request" || type === "quotation" && 
                (accountType === "admin" ||
                    accountType === "franchise_officer") ? (
                    <option value="edit-pi" className="color-options">
                        Edit
                    </option>
                ) : null}

                {(type === "open" || type === "closed") && accountType === "admin" ? (
                    <option value="edit-pi" className="color-options">
                        Edit
                    </option>
                ) : null}
                <option value="print-pi" className="color-options">
                    View
                </option>
                {type === "open" ? (
                    <option value="payment-pi" className="color-options">
                        Add Payment
                    </option>
                ) : null}
                {type === "request" ? (
                    <option value="add-invoice-pi" className="color-options">
                        Create Invoice
                    </option>
                ) : null}

                {type === "refundable" ? (
                    <option value="close-pi" className="color-options">
                        Close
                    </option>
                ) : null}

                {(accountType === "admin" ||
                    accountType === "franchise_officer") && (
                    <option value="delete-pi" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }
    const [selected, setSelected] = useState({});
    function AddPaymentBtn(row) {
        //
        // 
        //

        // setSelected(row);
        if(row.payment_status === "open_bill" || row.payment_status === "open bill") {
            return (
                <button
                    name="action"
                    className="btn btn-sm view-btn-table"
                    id={row.id}
                    onClick={(e) =>
                        handleSelectChange(
                            e,
                            row.id,
                            row.franchisee_id,
                            row.balance,
                            row
                        )
                    }
                    value="payment-pi"
                >
                    Pay
                </button>
            );
        }
        
    }
    function ViewBtn(row) {
        //
        //
        //
        setSelected(row);

        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={(e) =>
                    handleSelectChange(
                        e,
                        row.id,
                        row.franchisee_id,
                        row.balance
                    )
                }
                value="add-invoice-pi"
            >
                Invoice
            </button>
        );
    }

    function ProcessBtn(row) {
        setSelected(row);

        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={(e) =>
                    handleSelectChange(
                        e,
                        row.id,
                        row.franchisee_id,
                        row.balance
                    )
                }
                value="process-req"
            >
                Process
            </button>
        );
    }

    function ViewInvoice(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={(e) => handleSelectChange(e, row.id)}
                value="print-pi"
            >
                View
            </button>
        );
    }

    React.useEffect(() => {
        fetchFranchisee();
    }, []);

    React.useEffect(() => {
        return () => {}; // cleanup function
    }, []);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"FRANCHISE"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={6}>
                        <h1 className="page-title">RETAIL SALES INVOICE</h1>
                    </Col>
                    <Col xs={6} className="d-flex justify-content-end">
                        <input
                            type="search"
                            name="anything"
                            placeholder="Search..."
                            className="search-bar"
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") &&
                                handleFilterChange(e)
                            }
                        />
                        <button
                            className="add-btn"
                            onClick={() => navigate("/salesinvoice/add")}
                        >
                            Add
                        </button>
                    </Col>
                </Row>
                {
                    checkedItems.length > 0 && (
                        <>
                            <Row className="mb-1">
                                <Col xs={6}>
                                </Col>
                                <Col xs={6} className="d-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="button-primary justify-content-end"
                                        onClick={(e) =>
                                            handleSelectChange(e)
                                        }
                                        value="multiple-payment-pi"
                                    >
                                        Multiple Payment
                                    </button>
                                </Col>
                            </Row>
                        </>
                    )
                }

                <Tabs activeKey={filterConfig.tab} defaultActiveKey={filterConfig.tab} id="PO-tabs" onSelect={handleTabSelect}>
                    <Tab eventKey="order_quotation" title="ORDER QUOTE">
                        {/* filters */}
                        <div className="my-2 ms-2 PO-filters PI-filters d-flex">
                            <span className="me-3 align-middle mt-2">
                                Filter By:
                            </span>
                            <Select
                            className="dropsearch-filter px-0 py-0 me-2"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                  borderRadius: "7px",
                                  border: "0px",
                                  minHeight: "20px",
                                  maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                  }),
                                  dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  
                              }}
                            value={branch}
                            options={branches}
                            onChange={handleBranchChange}
                        />
                        </div>

                        {/* content */}
                        <div className="sales-tbl">
                            <AdjustmentTable
                                tableHeaders={[
                                    "-",
                                    // "INVOICE NO.",
                                    "ORDER DATE",
                                    "DLVRY DATE",
                                    "DOC. NO",
                                    "FRANCHISEE",
                                    "BRANCH",
                                    "TOTAL",
                                    "STATUS",
                                    "ACTIONS",
                                ]}
                                headerSelector={[
                                    "-",
                                    // "sales_invoice_no",
                                    "order_request_date",
                                    "delivery_date",
                                    "id",
                                    "franchisee_name",
                                    "buyer_branch_name",
                                    "balance",
                                    "payment_status",
                                ]}
                                tableData={salesInvoiceManager}
                                ActionBtn={(row) => ActionBtn(row, "quotation")}
                                ViewBtn={(row) => ProcessBtn(row)}
                                handleOnCheck={(row) => handleOnCheck(row)}
                                // PaymentBtn={(row) => AddPaymentBtn(row)}
                                showLoader={showLoader}
                            />
                        </div>
                        <div className="mb-2" />
                    </Tab>

                    <Tab eventKey="order_request" title="ORDER REQUEST">
                        {/* filters */}
                        <div className="my-2 ms-2 PO-filters PI-filters d-flex">
                            <span className="me-3 align-middle mt-2">
                                Filter By:
                            </span>
                            <Select
                            className="dropsearch-filter px-0 py-0 me-2"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                  borderRadius: "7px",
                                  border: "0px",
                                  minHeight: "20px",
                                  maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                  }),
                                  dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  
                              }}
                            value={branch}
                            options={branches}
                            onChange={handleBranchChange}
                        />
                        </div>

                        {/* content */}
                        <div className="sales-tbl">
                            <AdjustmentTable
                                tableHeaders={[
                                    "-",
                                    "*",
                                    // "INVOICE NO.",
                                    "ORDER DATE",
                                    "DLVRY DATE",
                                    "DOC. NO",
                                    "FRANCHISEE",
                                    "BRANCH",
                                    "TOTAL",
                                    "STATUS",
                                    "ACTIONS",
                                ]}
                                headerSelector={[
                                    "-",
                                    "*",
                                    // "sales_invoice_no",
                                    "order_request_date",
                                    "delivery_date",
                                    "id",
                                    "franchisee_name",
                                    "buyer_branch_name",
                                    "grand_total",
                                    "payment_status",
                                ]}
                                tableData={salesInvoiceManager}
                                ActionBtn={(row) => ActionBtn(row, "request")}
                                ViewBtn={(row) => ViewBtn(row)}
                                PaymentBtn={(row) => AddPaymentBtn(row)}
                                handleOnCheck={(row) => handleOnCheck(row)}
                                tableType="order_request"
                                showLoader={showLoader}
                            />
                        </div>
                        <div className="mb-2" />
                    </Tab>

                    <Tab eventKey="open_invoices" title="Open Invoice">
                        {/* filters */}
                        <div className="my-2 ms-2 PO-filters PI-filters d-flex">
                            <span className="me-3 align-middle mt-2">
                                Filter By:
                            </span>
                            <Select
                            className="dropsearch-filter px-0 py-0 me-2"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                  borderRadius: "7px",
                                  border: "0px",
                                  minHeight: "20px",
                                  maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                  }),
                                  dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  
                              }}
                            value={branch}
                            options={branches}
                            onChange={handleBranchChange}
                        />

                            <span className="me-4 ml-4 align-middle mt-2 ps-label">
                                Total: {numberFormat(total)}
                            </span>

                            <span className="me-4 ml-8 align-middle mt-2 ps-label">
                                Total Paid: {numberFormat(totalPaid)}
                            </span>

                            <span className="me-4 ml-8 align-middle mt-2 ps-label">
                                Total Balance: {numberFormat(totalBalance)}
                            </span>
                        </div> 

                        {/* content */}
                        <div className="">
                            <AdjustmentTable
                                tableHeaders={[
                                    "-",
                                    "SALES DATE",
                                    "INV NO.",
                                    "FRANCHISEE",
                                    "FROM",
                                    "BRANCH",
                                    "TOTAL",
                                    "PAID AMNT",
                                    "BALANCE",
                                    "STATUS",
                                    "ACTIONS",
                                ]}
                                headerSelector={[
                                    "-",
                                    "sales_date",
                                    "id",
                                    "franchisee_name",
                                    "seller_branch_name",
                                    "buyer_branch_name",
                                    "grand_total",
                                    "paid_amount",
                                    "balance",
                                    "payment_status",
                                ]}
                                tableData={salesInvoiceManager}
                                ActionBtn={(row) => ActionBtn(row, "open")}
                                ViewBtn={(row) => AddPaymentBtn(row)}
                                handleOnCheck={(row) => handleOnCheck(row)}
                                showLoader={showLoader}
                            />
                        </div>
                        <div className="mb-2" />
                    </Tab>

                    <Tab eventKey="closed_invoices" title="Closed Invoice">
                        {/* filters */}
                        <div className="my-2 ms-2 PO-filters PI-filters d-flex">
                            <span className="me-3 align-middle mt-2">
                                Filter By:
                            </span>
                            <Select
                                className="dropsearch-filter px-0 py-0 me-2"
                                classNamePrefix="react-select"
                                placeholder="Select Branch"
                                styles={{
                                    control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                    borderRadius: "7px",
                                    border: "0px",
                                    minHeight: "20px",
                                    maxHeight: "35px",
                                    }),
                                    input: (baseStyles, state) => ({
                                        ...baseStyles,
                                        color: state.isSelected? "white": "white",
                                        
                                    }),
                                    dropdownIndicator: (baseStyles, state) => ({
                                        ...baseStyles,
                                        color: "white"
                                        
                                    }),
                                    singleValue: (baseStyles, state) => ({
                                        ...baseStyles,
                                        color: "white"
                                        
                                    }),
                                    placeholder: (baseStyles, state) => ({
                                        ...baseStyles,
                                        color: "white"
                                        
                                    }),
                                    
                                }}
                                value={branch}
                                options={branches}
                                onChange={handleBranchChange}
                            />

                            <span className="me-3 align-middle mt-2">
                                Date From:
                            </span>
                            <DatePicker
                                    autoComplete="off"
                                name="date_from"
                                placeholderText={"Select Date"}
                                selected={filterConfig.date_from}
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_from: date };
                                    });
                                }}
                                // maxDate={dateToday}
                                fixedHeight
                                className="PI-date-btn me-3 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />

                            <span className="me-3 align-middle mt-2">To:</span>
                            <DatePicker
                                    autoComplete="off"
                                name="date_to"
                                placeholderText={"Select Date"}
                                selected={filterConfig.date_to}
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_to: date };
                                    });
                                }}
                                // maxDate={dateToday}
                                // minDate={filterConfig.date_from}
                                className="PI-date-btn me-3 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                        </div>

                        {/* content */}
                        <div className="sales-tbl">
                            <Table
                                tableHeaders={[
                                    "-",
                                    "SALES DATE",
                                    "INV NO.",
                                    "FRANCHISEE",
                                    "FROM",
                                    "BRANCH",
                                    "TOTAL",
                                    "PAID AMNT",
                                    "BALANCE",
                                    "STATUS",
                                    "ACTIONS",
                                ]}
                                headerSelector={[
                                    "-",
                                    "sales_date",
                                    "id",
                                    "franchisee_name",
                                    "seller_branch_name",
                                    "buyer_branch_name",
                                    "grand_total",
                                    "paid_amount",
                                    "balance",
                                    "payment_status",
                                ]}
                                tableData={salesInvoiceManager}
                                ActionBtn={(row) => ActionBtn(row, "closed")}
                                ViewBtn={(row) => ViewInvoice(row)}
                                showLoader={showLoader}
                            />
                        </div>
                        <div className="mb-2" />
                    </Tab>

                    <Tab eventKey="refundable" title="Refundable">
                        {/* filters */}
                        <div className="my-2 ms-2 PO-filters PI-filters d-flex">
                            <span className="me-3 align-middle mt-2">
                                Filter By:
                            </span>
                            <Select
                            className="dropsearch-filter px-0 py-0 me-2"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                  borderRadius: "7px",
                                  border: "0px",
                                  minHeight: "20px",
                                  maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                  }),
                                  dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  
                              }}
                            value={branch}
                            options={branches}
                            onChange={handleBranchChange}
                        />
                        </div>

                        {/* content */}
                        <div className="sales-tbl">
                            <Table
                                tableHeaders={[
                                    "-",
                                    "SALES DATE",
                                    "INV NO.",
                                    "FRANCHISEE",
                                    "FROM",
                                    "BRANCH",
                                    "TOTAL",
                                    "PAID AMNT",
                                    "RFND PMT",
                                    "STATUS",
                                    "ACTIONS",
                                ]}
                                headerSelector={[
                                    "-",
                                    "sales_date",
                                    "id",
                                    "franchisee_name",
                                    "seller_branch_name",
                                    "buyer_branch_name",
                                    "grand_total",
                                    "paid_amount",
                                    "balance",
                                    "payment_status",
                                ]}
                                tableData={salesInvoiceManager}
                                ActionBtn={(row) => ActionBtn(row, "refundable")}
                                ViewBtn={(row) => ViewInvoice(row)}
                                showLoader={showLoader}
                            />
                        </div>
                        <div className="mb-2" />
                    </Tab>
                    <Tab eventKey="all" title="All">
                        {/* filters */}
                        <div className="my-2 ms-2 PO-filters PI-filters d-flex">
                            <span className="me-3 align-middle mt-2">
                                Filter By:
                            </span>
                            <Select
                                className="dropsearch-filter px-0 py-0 me-2"
                                classNamePrefix="react-select"
                                placeholder="Select Branch"
                                styles={{
                                    control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                    borderRadius: "7px",
                                    border: "0px",
                                    minHeight: "20px",
                                    maxHeight: "35px",
                                    }),
                                    input: (baseStyles, state) => ({
                                        ...baseStyles,
                                        color: state.isSelected? "white": "white",
                                        
                                    }),
                                    dropdownIndicator: (baseStyles, state) => ({
                                        ...baseStyles,
                                        color: "white"
                                        
                                    }),
                                    singleValue: (baseStyles, state) => ({
                                        ...baseStyles,
                                        color: "white"
                                        
                                    }),
                                    placeholder: (baseStyles, state) => ({
                                        ...baseStyles,
                                        color: "white"
                                        
                                    }),
                                    
                                }}
                                value={branch}
                                options={branches}
                                onChange={handleBranchChange}
                            />

                            <span className="me-3 align-middle mt-2">
                                Date From:
                            </span>
                            <DatePicker
                                    autoComplete="off"
                                name="date_from"
                                placeholderText={"Select Date"}
                                selected={filterConfig.date_from}
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_from: date };
                                    });
                                }}
                                // maxDate={dateToday}
                                fixedHeight
                                className="PI-date-btn me-3 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />

                            <span className="me-3 align-middle mt-2">To:</span>
                            <DatePicker
                                    autoComplete="off"
                                name="date_to"
                                placeholderText={"Select Date"}
                                selected={filterConfig.date_to}
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_to: date };
                                    });
                                }}
                                // maxDate={dateToday}
                                // minDate={filterConfig.date_from}
                                className="PI-date-btn me-3 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                        </div>

                        {/* content */}
                        <div className="sales-tbl">
                            <Table
                                tableHeaders={[
                                    "-",
                                    "SALES DATE",
                                    "INV NO.",
                                    "FRANCHISEE",
                                    "FROM",
                                    "BRANCH",
                                    "TOTAL",
                                    "PAID AMNT",
                                    "BALANCE",
                                    "STATUS",
                                    "ACTIONS",
                                ]}
                                headerSelector={[
                                    "-",
                                    "sales_date",
                                    "id",
                                    "franchisee_name",
                                    "seller_branch_name",
                                    "buyer_branch_name",
                                    "grand_total",
                                    "paid_amount",
                                    "balance",
                                    "payment_status",
                                ]}
                                tableData={salesInvoiceManager}
                                ActionBtn={(row) => ActionBtn(row, "closed")}
                                ViewBtn={(row) => ViewInvoice(row)}
                                showLoader={showLoader}
                            />
                        </div>
                        <div className="mb-2" />
                    </Tab>
                </Tabs>
                <Row className="mt-3">
                    <Col className="d-flex justify-content-end mb-4">
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="button-primary"
                                onClick={handleExport}
                            >
                                <span className="me-2">
                                    <img
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                        alt=""
                                    ></img>
                                </span>
                                Download
                            </button>
                        </div>
                    </Col>
                </Row>
            </div>
            <DeleteModal
                show={showDeleteModal}
                onHide={() => handleCloseDeleteModal()}
                text="franchisee sales invoice"
                onDelete={() => handleDeletePI()}
                isClicked={isClicked}
            />
            <MultiplePaymentModal
                show={showAddPaymentModal}
                onHide={handleCloseAddPaymentModal}
                balance={bal}
                invoices={selectedItem}
            />
            <MultiplePaymentModal
                show={showMultiplePaymentModal}
                onHide={handleCloseMultiplePaymentModal}
                balance={bal}
                invoices={checkedItems}
            />
            <CloseFSModal
                show={showCloseBillModal}
                hide={handleCloseCloseBillModal}
                type="close"
                selectedRow={bill}
                page={"view"}
            />
        </div>
    );
}
